import React from 'react';
import PropTypes from 'prop-types';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {withRouter} from 'react-router';
import {flowRight as compose} from 'lodash';

const TabPage = ({tabs, defaultIndex, leading, location, history}) => {
  const params = new URLSearchParams(location.search);
  const index = params.has('tabIndex') ? +params.get('tabIndex') : defaultIndex;
  const changeSearchParamOnSelect = newIndex => {
    params.set('tabIndex', newIndex);
    history.replace(location.pathname + '?' + params.toString());
  };
  return (
    <Tabs defaultIndex={index} onSelect={changeSearchParamOnSelect}>
      <div className="react-tabs-custom">
        {leading && (
          <div className="react-tabs__tab">
            <div className="tab-name">{leading}</div>
          </div>
        )}
        <TabList>
          {tabs.map(({header}, index) => (
            <Tab key={index}>
              <div className="tab-name">{header}</div>
            </Tab>
          ))}
        </TabList>
      </div>
      {tabs.map(({content}, index) => (
        <TabPanel key={index}>{content}</TabPanel>
      ))}
    </Tabs>
  );
};

TabPage.defaultProps = {
  defaultIndex: 0,
  leading: null,
};

TabPage.propTypes = {
  tabs: PropTypes.array.isRequired,
  defaultIndex: PropTypes.number,
  leading: PropTypes.element,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
)(TabPage);
